// Caper Session Performance Schema - Metrics and Dimensions

export const Metrics = {
  // Overview Card Metrics
  COUNT_ORDERS: 'COUNT_ORDERS',
  SUM_GMV: 'SUM_GMV',
  AVG_BASKET_VALUE: 'AVG_BASKET_VALUE',
  AVG_BASKET_SIZE: 'AVG_BASKET_SIZE',
  LOYALTY_USAGE_RATE: 'LOYALTY_USAGE_RATE',

  // Session Metrics
  COUNT_SESSIONS: 'COUNT_SESSIONS',
  COUNT_COMPLETED_SESSIONS: 'COUNT_COMPLETED_SESSIONS',
  COUNT_ABANDONED_SESSIONS: 'COUNT_ABANDONED_SESSIONS',
  COUNT_NON_COMPLETED_SESSIONS: 'COUNT_NON_COMPLETED_SESSIONS',
  ABANDONMENT_RATE: 'ABANDONMENT_RATE',

  // User Order State Metrics
  COUNT_NEW_USERS: 'COUNT_NEW_USERS',
  COUNT_HABITUAL_USERS: 'COUNT_HABITUAL_USERS',
  COUNT_RESURRECTED_USERS: 'COUNT_RESURRECTED_USERS',
  COUNT_NEW_STORE_USERS: 'COUNT_NEW_STORE_USERS',
  COUNT_HABITUAL_STORE_USERS: 'COUNT_HABITUAL_STORE_USERS',
  COUNT_RESURRECTED_STORE_USERS: 'COUNT_RESURRECTED_STORE_USERS',

  // NPS Metrics
  AVG_NPS_SCORE: 'AVG_NPS_SCORE',
  COUNT_NPS_PROMOTERS: 'COUNT_NPS_PROMOTERS',
  COUNT_NPS_DETRACTORS: 'COUNT_NPS_DETRACTORS',
  NPS_RESPONSE_RATE: 'NPS_RESPONSE_RATE',

  // Core Audit Metrics
  COUNT_AUDITED_SESSIONS: 'COUNT_AUDITED_SESSIONS',
  COUNT_DISTINCT_AUDIT_ISSUE_TYPES: 'COUNT_DISTINCT_AUDIT_ISSUE_TYPES',
  COUNT_DISTINCT_AUDIT_ISSUES: 'COUNT_DISTINCT_AUDIT_ISSUES',
  AUDIT_RATE: 'AUDIT_RATE',
  NO_AUDIT_RATE: 'NO_AUDIT_RATE',
  PERCENT_SESSIONS_WITHOUT_EMPLOYEE_INTERVENTION: 'PERCENT_SESSIONS_WITHOUT_EMPLOYEE_INTERVENTION',
  AVG_AUDIT_WAIT_TIME_MINUTES: 'AVG_AUDIT_WAIT_TIME_MINUTES',
  AVG_AUDIT_RESOLVED_TIME_MINUTES: 'AVG_AUDIT_RESOLVED_TIME_MINUTES',
  COUNT_FORCE_RESOLVED_AUDITS: 'COUNT_FORCE_RESOLVED_AUDITS',
  FORCE_RESOLVE_RATE: 'FORCE_RESOLVE_RATE',
  COUNT_RESOLVE_ALL_CLICKED: 'COUNT_RESOLVE_ALL_CLICKED',
  RESOLVE_ALL_CLICKED_RATE: 'RESOLVE_ALL_CLICKED_RATE',
  AVG_FLAGGED_ISSUES: 'AVG_FLAGGED_ISSUES',
  AVG_FLAGGED_ISSUES_RATE: 'AVG_FLAGGED_ISSUES_RATE',
  AVG_CHECKOUT_AUDIT_SCORE: 'AVG_CHECKOUT_AUDIT_SCORE',
  COUNT_FRAUD_THRESHOLD_EXCEEDED: 'COUNT_FRAUD_THRESHOLD_EXCEEDED',
  FRAUD_THRESHOLD_EXCEEDED_RATE: 'FRAUD_THRESHOLD_EXCEEDED_RATE',

  // Audit Issue Breakdown Metrics
  COUNT_AGE_RESTRICTED_ISSUES: 'COUNT_AGE_RESTRICTED_ISSUES',
  COUNT_PERSONAL_ISSUES: 'COUNT_PERSONAL_ISSUES',
  COUNT_WEIGHT_MISMATCH_ISSUES: 'COUNT_WEIGHT_MISMATCH_ISSUES',
  COUNT_REMOVAL_MISMATCH_ISSUES: 'COUNT_REMOVAL_MISMATCH_ISSUES',
  COUNT_PRODUCE_AUDIT_ISSUES: 'COUNT_PRODUCE_AUDIT_ISSUES',
  COUNT_SCALE_RESET_ISSUES: 'COUNT_SCALE_RESET_ISSUES',
  COUNT_SCALE_RESET_ADD_REMOVE_ISSUES: 'COUNT_SCALE_RESET_ADD_REMOVE_ISSUES',
  SUM_AUDIT_ISSUES: 'SUM_AUDIT_ISSUES',
  AVG_AUDIT_ISSUES_PER_SESSION: 'AVG_AUDIT_ISSUES_PER_SESSION',
  COUNT_AUDIT_ISSUES_BY_TYPE: 'COUNT_AUDIT_ISSUES_BY_TYPE',

  // QR Code Metrics
  COUNT_SESSIONS_SINGLE_QR: 'COUNT_SESSIONS_SINGLE_QR',
  COUNT_SESSIONS_MULTIPLE_QR: 'COUNT_SESSIONS_MULTIPLE_QR',
  MULTIPLE_QR_RATE: 'MULTIPLE_QR_RATE',

  // Loyalty Metrics
  COUNT_SESSIONS_WITH_LOYALTY: 'COUNT_SESSIONS_WITH_LOYALTY',

  // Coupon Metrics
  COUNT_SESSIONS_WITH_COUPONS: 'COUNT_SESSIONS_WITH_COUPONS',
  SUM_COUPON_VALUE: 'SUM_COUPON_VALUE',
  SUM_COUPON_VALUE_CAPER_FUNDED: 'SUM_COUPON_VALUE_CAPER_FUNDED',
  SUM_COUPON_VALUE_DEALSHUB: 'SUM_COUPON_VALUE_DEALSHUB',
  SUM_COUPON_VALUE_ALERT: 'SUM_COUPON_VALUE_ALERT',
  SUM_COUPON_VALUE_OFFLINE: 'SUM_COUPON_VALUE_OFFLINE',
  AVG_COUPONS_PER_SESSION: 'AVG_COUPONS_PER_SESSION',
  AVG_COUPONS_PER_ORDER: 'AVG_COUPONS_PER_ORDER',
  COUPON_REDEMPTION_RATE: 'COUPON_REDEMPTION_RATE',

  // Duration Metrics
  AVG_SESSION_DURATION_MINUTES: 'AVG_SESSION_DURATION_MINUTES',
  AVG_CHECKOUT_DURATION_MINUTES: 'AVG_CHECKOUT_DURATION_MINUTES',

  // Item Metrics
  AVG_ITEMS_IN_CART: 'AVG_ITEMS_IN_CART',
  AVG_MAX_ITEMS_IN_CART: 'AVG_MAX_ITEMS_IN_CART',
  SUM_ITEMS_AT_CHECKOUT: 'SUM_ITEMS_AT_CHECKOUT',
  AVG_ITEMS_PER_SESSION: 'AVG_ITEMS_PER_SESSION',
  AVG_TRASH_CAN_CLICKS_PER_SESSION: 'AVG_TRASH_CAN_CLICKS_PER_SESSION',

  // Cart Utilization Metrics
  COUNT_UNIQUE_CARTS: 'COUNT_UNIQUE_CARTS',
  COUNT_SESSIONS_PER_CART: 'COUNT_SESSIONS_PER_CART',
  AVG_SESSIONS_PER_CART: 'AVG_SESSIONS_PER_CART',
  AVG_USERS_PER_CART_PER_DAY: 'AVG_USERS_PER_CART_PER_DAY',
  AVG_AVAILABLE_CART_HOURS: 'AVG_AVAILABLE_CART_HOURS',
  PEAK_DAILY_UTILIZATION: 'PEAK_DAILY_UTILIZATION',
  AVG_DAILY_INFERRED_STORE_HOURS: 'AVG_DAILY_INFERRED_STORE_HOURS',
  COUNT_AUDITED_CARTS: 'COUNT_AUDITED_CARTS',
  COUNT_ACTIVE_STORES: 'COUNT_ACTIVE_STORES',

  // ETL Metadata
  MAX_UPDATED_AT_DATE_TIME_UTC: 'MAX_UPDATED_AT_DATE_TIME_UTC',
} as const

export const Dimensions = {
  // Time Dimensions
  DATE_PT: 'DATE_PT',
  WEEK_PT: 'WEEK_PT',
  MONTH_PT: 'MONTH_PT',
  HOUR_PT: 'HOUR_PT',

  // Core Access Control Dimensions
  PARTNER: 'PARTNER',
  WAREHOUSE: 'WAREHOUSE',
  WAREHOUSE_LOCATION: 'WAREHOUSE_LOCATION',
  WAREHOUSE_LOCATION_STATE: 'WAREHOUSE_LOCATION_STATE',
  RETAILER: 'RETAILER',

  // Store Dimensions
  RETAILER_LOCATION_NAME: 'RETAILER_LOCATION_NAME',
  STORE_PARTNER_GROUP: 'STORE_PARTNER_GROUP',
  PARTNER_NAME: 'PARTNER_NAME',
  STORE_NICKNAME: 'STORE_NICKNAME',
  WAREHOUSE_ID: 'WAREHOUSE_ID',
  WAREHOUSE_LOCATION_ID: 'WAREHOUSE_LOCATION_ID',
  STORE_ID: 'STORE_ID',
  RETAILER_NAME: 'RETAILER_NAME',

  // Identifier Dimensions
  SESSION_ID: 'SESSION_ID',
  SESSION_START_TIME_LOCAL: 'SESSION_START_TIME_LOCAL',
  SESSION_END_TIME_LOCAL: 'SESSION_END_TIME_LOCAL',
  SESSION_START_DATE_TIME_LOCAL: 'SESSION_START_DATE_TIME_LOCAL',
  SESSION_END_DATE_TIME_LOCAL: 'SESSION_END_DATE_TIME_LOCAL',
  ORDER_ID: 'ORDER_ID',
  DEVICE_ID: 'DEVICE_ID',
  DEVICE_NAME: 'DEVICE_NAME',
  CART_ID: 'CART_ID',
  CART_NAME: 'CART_NAME',

  // Session Status Dimensions
  IS_COMPLETED: 'IS_COMPLETED',
  IS_ABANDONED: 'IS_ABANDONED',
  ABANDONMENT_CATEGORY: 'ABANDONMENT_CATEGORY',
  NPS_LABEL: 'NPS_LABEL',
  HAS_NPS: 'HAS_NPS',

  // User Order State Dimensions
  USER_ORDER_STATE: 'USER_ORDER_STATE',
  STORE_USER_ORDER_STATE: 'STORE_USER_ORDER_STATE',

  // Loyalty Dimensions
  HAS_LOYALTY_PROGRAM: 'HAS_LOYALTY_PROGRAM',

  // Audit Dimensions
  CHECKOUT_AUDIT_REQUIRED: 'CHECKOUT_AUDIT_REQUIRED',
  HAS_CHECKOUT_AUDIT: 'HAS_CHECKOUT_AUDIT',
  AUDIT_RESOLUTION_METHOD: 'AUDIT_RESOLUTION_METHOD',
  IS_FORCE_RESOLVED: 'IS_FORCE_RESOLVED',
  RESOLVE_ALL_CLICKED: 'RESOLVE_ALL_CLICKED',
  CHECKOUT_AUDIT_SCORE: 'CHECKOUT_AUDIT_SCORE',
  AUDIT_ISSUE_TYPE: 'AUDIT_ISSUE_TYPE',
  AUDIT_ISSUE_ID: 'AUDIT_ISSUE_ID',
  AUDIT_ISSUE_SUB_CATEGORY: 'AUDIT_ISSUE_SUB_CATEGORY',
  STAFF_BARCODE: 'STAFF_BARCODE',
  STAFF_USER_NAME: 'STAFF_USER_NAME',
  STORE_AUDIT_SCORE_THRESHOLD: 'STORE_AUDIT_SCORE_THRESHOLD',
  NUM_FRAUD_THRESHOLDS_EXCEEDED: 'NUM_FRAUD_THRESHOLDS_EXCEEDED',

  // Coupon Dimensions
  COUPON_SOURCE: 'COUPON_SOURCE',
  HAS_COUPONS: 'HAS_COUPONS',

  // QR Code Dimensions
  QR_CODE_COUNT: 'QR_CODE_COUNT',

  // Cart Utilization Dimensions
  DAILY_DEPLOYED_UTILIZATION: 'DAILY_DEPLOYED_UTILIZATION',
  DAILY_AVAILABLE_UTILIZATION: 'DAILY_AVAILABLE_UTILIZATION',
} as const
